import React from 'react';

export default function IconWatchlist() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.29892 1.40521L10.1389 5.15188L14.2723 5.74521C14.5456 5.78521 14.6523 6.11855 14.4589 6.31188L11.4656 9.22521L12.1789 13.3385C12.2256 13.6119 11.9389 13.8185 11.6923 13.6919L7.99892 11.7452L4.30559 13.6919C4.05893 13.8185 3.77226 13.6119 3.81892 13.3385L4.53226 9.22521L1.53893 6.31188C1.33893 6.11855 1.45226 5.78521 1.72559 5.74521L5.85892 5.15188L7.69892 1.40521C7.81892 1.15855 8.17226 1.15855 8.29892 1.40521Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
